import { createSlice } from "@reduxjs/toolkit";
import { reverseGeocodeData } from "../../../type/admins/reverse-geocode-data";

export const reverseGeocodedFarmsData = createSlice({
  name: "reverse-geocode-farms-data",
  initialState: {
    value: {
      status: false,
      data: [] as reverseGeocodeData[],
      statesFiltered: [] as reverseGeocodeData[],
      regionFiltered: [] as reverseGeocodeData[],
    },
  },
  reducers: {
    updateReverseGeocodeFarms: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
      state.value.statesFiltered = action?.payload?.statesFiltered;
      state.value.regionFiltered = action?.payload?.regionFiltered;
    },
    addReverseGeocodeFarmToList: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    removeReverseGeocodeFarmInList: (state, action) => {
      const { _id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { _id: string }) => v._id === _id
      );
      if (currentIndex >= 0) {
        currentArray.splice(currentIndex, 1);
        state.value.data = currentArray;
      }
    },
    replaceReverseGeocodeFarmInList: (state, action) => {
      const { _id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { _id: string }) => v._id === _id
      );
      if (currentIndex >= 0) {
        currentArray.splice(currentIndex, 1, action?.payload);
        state.value.data = currentArray;
      }
    },
    clearReverseGeocodeFarmList: (state) => {
      state.value.status = false;
      state.value.data = [];
      state.value.statesFiltered = [];
      state.value.regionFiltered = [];
    },
  },
});

export const {
  updateReverseGeocodeFarms,
  addReverseGeocodeFarmToList,
  removeReverseGeocodeFarmInList,
  replaceReverseGeocodeFarmInList,
  clearReverseGeocodeFarmList,
} = reverseGeocodedFarmsData.actions;

export default reverseGeocodedFarmsData.reducer;
